import _ from 'lodash'
import {evalExpression, IExpressionConfig, stringifyExpressionConfig} from '@/features/expressions'
import {IDataSource, IDataSourceItem} from '.'

export function expressionSource<
  T extends {catalog: IDataSourceItem[]; expressionConfig: IExpressionConfig},
>(args: T): IDataSource<T> {
  const {catalog, expressionConfig} = args

  return {
    sourceID: 'expression',
    key: stringifyExpressionConfig(expressionConfig),
    args,
    fetch: async () => {
      const res = _.chain(catalog)
        .map((item) => [item._id, evalExpression(expressionConfig.expression, item).result])
        .fromPairs()
        .value()
      return res
    },
  }
}
